import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  constructor(private ws: PostmethodService) { }

  createArea(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/area");
  }

  updateArea(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/area", id);
  }

  getArea() {
    return this.ws.wsGet(environment.baseUrl + "masters/area");
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZoneByCountry(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-zones-by-country", id);
  }

  getStateByZone(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-states-by-zone", id);
  }

  getRegionByState(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-regions-by-state", id);
  }

  getDistrictByRegion(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-districts-by-region", id);
  }
}
